import React from "react";
import DeleteBtn from "../../../Utilities/DeleteBtn";
import TagInput from "../../../Utilities/TagInput";
import MultiSelectDropdown from "../../../Utilities/MultiSelectDropdown";

// ── ColumnCard ────────────────────────────────────────────────────────────────
// Renders a single column definition: Label input + Type select + Delete button
// + optional unit multiselect (number) or tag input (dropdown) below.
const ColumnCard = ({
  col,
  onLabelChange,
  onTypeChange,
  onDelete,
  onOptionsChange,
  showType = true,
  unitMasters = [],
}) => {
  // Map unit masters to the shape MultiSelectDropdown expects
  const unitOptions = unitMasters.map((u) => ({ value: u.id, label: u.unit }));
  // dropdown_options stores numeric IDs for number columns
  const selectedUnitIds = (col.dropdown_options || []).map(Number);

  return (
    <div className="p-2 border rounded bg-white shadow-sm">
      {/* Labels row */}
      <div className="d-flex gap-2 mb-1">
        <div style={{ flex: "1 1 0" }}>
          <label className="form-label small mb-0 text-muted fw-normal">label</label>
        </div>
        {showType && (
          <div style={{ width: "110px" }}>
            <label className="form-label small mb-0 text-muted fw-normal">type</label>
          </div>
        )}
        <div style={{ width: "32px" }} />
      </div>

      {/* Inputs row */}
      <div className="d-flex gap-2 align-items-center">
        <div style={{ flex: "1 1 0", minWidth: 0 }}>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Column name"
            value={col.label}
            onChange={(e) => onLabelChange(e.target.value)}
          />
        </div>
        {showType && (
          <div style={{ width: "110px" }}>
            <select
              className="form-select form-select-sm"
              value={col.data_type || "string"}
              onChange={(e) => onTypeChange(e.target.value)}
            >
              <option value="string">Text</option>
              <option value="number">Number</option>
              <option value="dropdown">Dropdown</option>
            </select>
          </div>
        )}
        <div style={{ width: "32px" }}>
          <DeleteBtn onClick={onDelete} title="Remove Column" size={31} />
        </div>
      </div>

      {/* Unit multiselect — shown when data_type is "number" */}
      {showType && col.data_type === "number" && (
        <div className="mt-2">
          <MultiSelectDropdown
            label="Units"
            icon="fas fa-ruler-combined"
            placeholder="Select unit(s)"
            options={unitOptions}
            selectedValues={selectedUnitIds}
            onChange={(ids) => onOptionsChange(ids)}
          />
        </div>
      )}

      {/* Dropdown options */}
      {showType && col.data_type === "dropdown" && (
        <div className="mt-2">
          <label className="form-label small mb-1">Options</label>
          <TagInput tags={col.dropdown_options} onChange={onOptionsChange} />
        </div>
      )}
    </div>
  );
};

export default ColumnCard;
